<div class="inputSearch {{layoutModifier}}">
  <form [formGroup]="form" class="form">
    <div class="form-inputWrapper">
      <app-input [type]="'text'" [placeholder]="placeholder" [mainForm]="form" [controlName]="controlName"
        [layoutMod]="['searchIcon']">
      </app-input>
    </div>
  </form>
</div>
